import React, {useEffect, useState} from 'react'
import './CourseContent.css'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import axios from 'axios'
import FormData from 'form-data';
import DownloadIcon from '@mui/icons-material/Download';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

function CourseContent({ orgId }) {
  const classOptions = [
    { value: 'Class-10', label:'class-10'},
    { value: 'Class-9', label:'class-9'},
    { value: 'Class-8', label:'class-8'}
  ]
  const [selectedClass, setSelectedClass] = useState(null)

  const subjectOptions = [
    { value: 'science', label:'Science'},
    { value: 'socialscience', label:'Social Science'},
    { value: 'maths', label:'Maths'}
  ]
  const [selectedSubject, setSelectedSubjected] = useState(null)

  const [data, setData] = useState([]);

  useEffect(()=>{
    axios.get(`http://localhost:8010/organizations/api/coursecontents/list/ff5a071a-0836-404f-ae27-9e76f20a6c84`)
      .then(response => {
        setData(response.data)
      })
      .catch(error => {
        console.log(error)
      });
  },[])

  const handleDelete = (id) => {
    console.log(id)
  };

  const handleMultiDelete = () => {
    setData(data.filter(item => !item.selected));
  };

  const handleCheckboxChange = (id) => {
    // setData(data.map(item => {
    //   if (item.id === id) {
    //     return { ...item, selected: !item.selected };
    //   }
    //   return item;
    // }));
  };

  const handleDownload = (filepath) => {
    const pathLink = 'https://coursecontents.s3.ap-south-1.amazonaws.com/'+filepath;
    console.log(filepath)
    window.open(pathLink,'_blank');
  };

  const [editRowId, setEditRowId] = useState(null);
  const [editRowData, setEditRowData] = useState({});
  const handleEditClick = (item) => {
    setEditRowId(item.courseContentId);
    setEditRowData(item);
  };
  const handleSaveClick = (id) => {
    handleEdit(editRowData); 
    setEditRowId(null);
  };

  const handleInputChange = (e, field) => {
    setEditRowData({
      ...editRowData,
      [field]: e.target.value
    });
  };

  const handleEdit = (item) => {
    console.log(item)
  };

  const [fileName, setFileName] = useState('')
  const [fileType, setFileType] = useState('')
  const [fileDescription, setFileDescription] = useState('')
  const [courseContents, setCourseContents] = useState('')

  useEffect(()=>{
     setCourseContents({
      "orgId": orgId,
      "courseId": "ff5a071a-0836-404f-ae27-9e76f20a6c84",
      "name": fileName,
      "type": fileType,
      "description": fileDescription,
      "uploadBy": "7a7f8725-4338-4f6b-9a0a-1d7c303d891b"
    })
  },[fileName, fileType, fileDescription])

  const [uploadActive, setUploadActive] = useState(false)
  const openUpload = () => {
    setUploadActive(true)
  }

  const formData = new FormData();

  const handleFileChange = (event) => {
    // setSelectedFile(event.target.files[0])
    if(event.target && event.target.files[0]){
      formData.append('file', event.target.files[0]);
    }
  };

  const [uploadSuccess, setUploadSuccess] = useState(false)
  const handleUpload = (e) => {
    e.preventDefault()
    console.log(courseContents)
    if (!formData.get('file')) {
      toast.warning('Please select a file.');
      return;
    }

    formData.append('courseContents', new Blob([JSON.stringify(courseContents)], {
      type: "application/json"
    }));
   
    axios.post(
      'http://mygurukul.egurukulapps.com/organizations/api/coursecontents/upload',
      formData,
      {
        headers: {
          'Content-Type': undefined
        }
      }
    )
    .then((response) => {
      console.log('upload Successful')
      console.log(response.data);
      setUploadSuccess(true)
    })
    .catch((error) => {
      console.log(error);
    });

  }



  return (
    <div>

      <div className='heading-course-content'>Course Content</div>
      {/* Class and Subject */}
      <div className="wrap-ccselection">
        <div className="ccselect">
          <div className="ccselect-title">Class</div>
          <div className="wrap-ccselect-class"> 
            <Select className="ccselect-class" defaultValue={selectedClass} options={classOptions} onChange={setSelectedClass}>        
            </Select>
          </div>
        </div>
        <div className="ccselect">
          <div className="ccselect-title">Subject</div>
          <div className="wrap-ccselect-class"> 
            <Select className="ccselect-class" defaultValue={selectedSubject} options={subjectOptions} onChange={setSelectedSubjected}>        
            </Select>
          </div>
        </div>
        <div className="wrap-ccselect-view">
          <button className="ccselect-view">View</button>
        </div>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Select</th>
              <th>Title</th>
              <th>Type</th>
              <th>Date</th>
              <th>Remarks</th>
              <th className="checkbox-cell">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map(item => (
              <tr key={item.courseContentId}>
                <td>
                  <input type="checkbox" checked={item.selected} onChange={() => handleCheckboxChange(item.id)}/>
                </td>
                {editRowId === item.courseContentId ? (
                <>
                  <td><input type="text" value={editRowData.name} onChange={(e) => handleInputChange(e, 'name')} /></td>
                  <td><input type="text" value={editRowData.type} onChange={(e) => handleInputChange(e, 'type')} /></td>
                  <td><input type="date" value={editRowData.dateOfUpload} onChange={(e) => handleInputChange(e, 'dateOfUpload')} /></td>
                  <td><input type="text" value={editRowData.description} onChange={(e) => handleInputChange(e, 'description')} /></td>
                </>
              ) : (
                <>
                  <td>{item.name}</td>
                  <td>{item.type}</td>
                  <td>{item.dateOfUpload}</td>
                  <td>{item.description}</td>
                </>
              )}
                <td className="checkbox-cell">
                  <button onClick={() => handleDownload(item.filepath)}><DownloadIcon style={{fontSize:"16px"}} /></button>
                  {editRowId === item.courseContentId ? (
                    <button onClick={() => handleSaveClick(item.courseContentId)}>Save</button>
                  ) : (
                    <button onClick={() => handleEditClick(item)}><EditIcon style={{ fontSize: "16px" }} /></button>
                  )}
                  <button onClick={() => handleDelete(item.courseContentId)}><DeleteIcon style={{fontSize:"16px"}}/></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/*Delete and Upload Course Contents*/}
        <div className="actions-container">
          <button onClick={handleMultiDelete}> x Delete Selected</button>
          <button className="upload-button" onClick={openUpload}> + Upload </button>
        </div>
      </div>

      {uploadActive && <div className="wrap-upload-popup">
        <div className="upload-popup">
          <div className="close-upload-popup">
            <button onClick={()=>{setUploadActive(false);setUploadSuccess(false)}}>X</button>
          </div>
          <div className="item-upload-popup">
            <label>File name</label>
            <input type="text" name="fileName" value={fileName} placeholder='New_Document' onChange={(e)=>setFileName(e.target.value)}/>
          </div>
          <div className="item-upload-popup">
            <label>File type</label>
            <input type="text" name="fileType" value={fileType} placeholder='.pdf, .docx' onChange={(e)=>setFileType(e.target.value)}/>
          </div>
          <div className="item-upload-popup">
            <label>Description</label>
            <textarea type="text" name="fileDescription" value={fileDescription} onChange={(e)=>setFileDescription(e.target.value)}/>
          </div>
          <div className="item-upload-popup">
            <input type="file" onChange={handleFileChange} />
          </div>
          <div className="upload-button-popup">
            <button onClick={handleUpload}> Upload </button>
          </div>
          {uploadSuccess && <div className="item-upload-popup">
            <span>Upload Successful</span>
          </div>}
        </div>
      </div>}

    </div>
  );
}

export default CourseContent